module.exports = __webpack_public_path__ + "img/wx.06bc1f7f.png";